module.exports = __webpack_public_path__ + "img/occidental-hotel-2.753bd82e.jpg";